import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { CheckCircle2, ClipboardList } from "lucide-react";
import { http } from "@/lib/api";

export const AssignedSection = () => {
  const [items, setItems] = useState([]);
  useEffect(() => { http.get("/assigned").then((r) => setItems(r.data)).catch(() => {}); }, []);
  if (!items.length) return null;
  return (
    <section className="mt-12" data-testid="assigned-section">
      <h2 className="font-display text-2xl text-[#2C4A3E] inline-flex items-center gap-2"><ClipboardList className="w-5 h-5 text-[#C87D53]" />Assigned by your teacher</h2>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 mt-5">
        {items.map((a) => (
          <Link key={a.id} to={`/learn/${a.subject_id}?assigned=${a.id}`} data-testid={`assigned-card-${a.id}`}
            className="rounded-3xl p-5 bg-white/70 border border-[#E6DEC3] hover:border-[#2C4A3E] hover:-translate-y-0.5 transition-[transform,border-color]">
            <div className="flex justify-between text-xs uppercase tracking-widest text-[#C87D53] font-semibold">
              <span>{a.subject_name}</span>
              {a.completed && <span className="inline-flex items-center gap-1 text-[#6B9080] normal-case tracking-normal" data-testid={`assigned-done-${a.id}`}><CheckCircle2 className="w-4 h-4" />Done</span>}
            </div>
            <p className="font-display text-lg text-[#2C4A3E] mt-2">{a.topic}</p>
            <p className="text-xs text-stone-500 mt-1">{a.class_name}</p>
          </Link>
        ))}
      </div>
    </section>
  );
};
